module.exports = __webpack_public_path__ + "img/bottom-bg.d3ffc9e1.png";